import React from "react";
import Login from "../routes/Login";
import {useAuth} from "./Auth";

const ProtectedRoute = props => {
    const { as: Component, ...rest } = props;
    const auth = useAuth();
    const isSignedInSpeedwellUser = () => {
        return auth.isSignedIn /*&& (auth.getHostedDomain() === 'speedwellholdings.com')*/
    };

    return isSignedInSpeedwellUser()() ? <Component {...rest} /> : <Login />;
};

export default ProtectedRoute;
